import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { ApiService } from "../../services/api";

// Koçum'da bir kez sorulur (25 Eki — sahibin kararı): ödev ve hatırlatmalar WhatsApp'tan gelsin mi. Kurumda WhatsApp açıksa,
// öğrencinin cep telefonu kayıtlıysa ve henüz karar vermemişse görünür; cevap verince kaybolur. "Bugün" ekranını asla
// bloklamaz: istek düşerse kart görünmez.
export default function WhatsappIzinCard() {
  const [data, setData] = useState<{ goster: boolean; numara: string | null } | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    ApiService.getWhatsappIzin().then(setData).catch(() => setData(null));
  }, []);

  const karar = async (izin: boolean) => {
    setBusy(true);
    setErr(null);
    try {
      await ApiService.setWhatsappIzin(izin);
      setDone(izin ? "Tamam, ödevlerin ve hatırlatmaların WhatsApp'tan da gelecek. Durdurmak istersen \"RET\" yazman yeterli." : "Tamam, WhatsApp'tan mesaj göndermeyeceğiz.");
    } catch {
      setErr("Kaydedilemedi; biraz sonra yeniden dene.");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-800 sm:p-4">{done}</div>;
  }
  if (!data?.goster) return null;
  return (
    <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-3 sm:p-4">
      <div className="flex items-start gap-2">
        <MessageCircle className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
        <p className="min-w-0 flex-1 text-sm text-emerald-900">
          <span className="font-semibold">Ödevlerin ve hatırlatmaların WhatsApp'tan da gelsin mi?</span>{" "}
          Yeni ödev verildiğinde ya da planında bekleyen bir iş olduğunda kısa bir mesaj atarız{data.numara ? ` (${data.numara})` : ""}. İstediğin zaman "RET" yazarak durdurabilirsin.
        </p>
      </div>
      {err && <p className="mt-2 text-xs text-red-600">{err}</p>}
      <div className="mt-2.5 flex flex-col gap-2 sm:flex-row">
        <button
          onClick={() => karar(true)}
          disabled={busy}
          className="inline-flex items-center justify-center rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-emerald-700 disabled:opacity-60"
        >
          Evet, gelsin
        </button>
        <button
          onClick={() => karar(false)}
          disabled={busy}
          className="inline-flex items-center justify-center rounded-lg border border-emerald-300 bg-white px-4 py-2 text-sm font-medium text-emerald-800 transition-colors hover:bg-emerald-100 disabled:opacity-60"
        >
          Hayır
        </button>
      </div>
    </div>
  );
}
